/*eslint-disable */
import providerType from './provider-type'

export const deviceTypes = {
    ANDROID: 'android',
    IPHONE: 'iphone'
}

export const mobileDeviceTypes = {
    [deviceTypes.IPHONE]: 'iPhone',
    [deviceTypes.ANDROID]: 'Android'
}

export const mobileIcons = {
    'dark': {
        android : '/img/logos/mfa/android-dark.svg?url',
        iphone: '/img/logos/mfa/iphone-dark.svg?url'
    },
    'light': {
        android : '/img/logos/mfa/android-light.svg?url',
        iphone: '/img/logos/mfa/iphone-light.svg?url'
    }
}
export const downloadLink = {
    [providerType.GOOGLE] : {
        [deviceTypes.IPHONE]: 'https://apps.apple.com/us/app/google-authenticator/id388497605',
        [deviceTypes.ANDROID]: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2' 
    },
    [providerType.OKTA] : {
        [deviceTypes.IPHONE]: 'https://apps.apple.com/us/app/okta-verify/id490179405',
        [deviceTypes.ANDROID]: 'https://play.google.com/store/apps/details?id=com.okta.android.auth' 
    }   
}